import React, {useCallback, useMemo, useState} from "react";
import {Col} from "reactstrap";
import FreeShippingFeesManagementViewSettingsGeneralExceptions from "./sections/general";
import FreeShippingFeesManagementViewSettingsProductsExceptions from "./sections/products";
import FreeShippingFeesManagementViewSettingsRegionsExceptions from "./sections/regions";
import FreeShippingFeesManagementViewSettingsCompaniesExceptions from "./sections/companies";
import FreeShippingFeesManagementViewSettingsCategoriesExceptions from "./sections/categories";
import FreeShippingFeesManagementViewSettingsPriceLevelsExceptions from "./sections/price-levels";
import FreeShippingFeesManagementViewSettingsOrderSimulation from "./sections/order-simulation";
import Button from "../../../../../../../components/base/button/button";
import {routes} from "../../../../../../../../core/models/static/routes/app-routes";
import FreeShippingFeesManagementViewSettingsSettingsSection from "./sections/settings";
import {Link} from "react-router-dom";

/**
 * The available Actions for the free shipping fees management view
 */
export const FreeShippingFeesManagementViewDataGridActionNames = {
    Delete: 'delete'
}


const FreeShippingFeesManagementViewSettings = ({
                                                    inUsersPanel,
                                                    customerDetached,
                                                    reattachCustomerToSystemRules,
                                                    customer,
                                                    detachCustomerFromSystemRules
                                                }) => {
    const [syncWithDetachedCustomers, setSyncWithDetachedCustomers] = useState(false);
    const [refresher, setRefresher] = useState(false);

    /**
     * Refreshes the exceptions view.
     * @type {(function(): void)|*}
     */
    const refreshExceptions = useCallback(() => {
        setRefresher(prevState => !prevState);
    }, [])

    const customerProps = useMemo(() => !inUsersPanel ? {} : {
        customerId: customer?.id,
        customerName: customer?.name,
    }, [customer?.id, customer?.name, inUsersPanel])

    return (
        <>
            <div className={'exceptions-view'}>
                {
                    inUsersPanel && !customerDetached &&
                    <>
                        <Col xs={12} md={6} className={'m-auto'}>
                            <div className={'section'}>
                                <div className={'section-paper d-flex flex-column align-items-center'}>
                                    <p className={'text-sm'}>
                                        {customer?.name} is following the system's free shipping rules.
                                    </p>
                                    <Button
                                        variant={'contained'}
                                        onClick={detachCustomerFromSystemRules}
                                        color={'primary'}
                                        className={'mt-4'}
                                    >
                                        Detach Customer to add custom rules
                                    </Button>
                                    <Button
                                        variant={'text'}
                                        className={'mt-3'}
                                        component={Link}
                                        to={routes.shippingFees.settings}
                                    >
                                        View system rules
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </>
                }
                {
                    !(inUsersPanel && !customerDetached) &&
                    <>
                        <Col xs={{size: 12, order: 1}} lg={{size: 4, order: 2}} xl={6} className={'mb-5'}>
                            <div className={'order-simulation-container'}>
                                <FreeShippingFeesManagementViewSettingsSettingsSection
                                    inUsersPanel={inUsersPanel}
                                    customerDetached={customerDetached}
                                    syncWithDetachedCustomers={syncWithDetachedCustomers}
                                    setSyncWithDetachedCustomers={setSyncWithDetachedCustomers}
                                    reattachCustomerToSystemRules={reattachCustomerToSystemRules}
                                />
                                <FreeShippingFeesManagementViewSettingsOrderSimulation
                                    refreshExceptions={refreshExceptions}
                                />
                            </div>
                        </Col>
                        <Col xs={{size: 12, order: 2}} lg={{size: 8, order: 1}} xl={6} className={'mb-5'}>
                            <p className={'text-sm mb-4'}>
                                By default, the freight's cost will be free, except for the following conditions:
                            </p>
                            <FreeShippingFeesManagementViewSettingsGeneralExceptions
                                syncWithDetachedCustomers={syncWithDetachedCustomers}
                                {...customerProps}
                                refresher={refresher}
                            />
                            <FreeShippingFeesManagementViewSettingsProductsExceptions
                                syncWithDetachedCustomers={syncWithDetachedCustomers}
                                {...customerProps}
                                refresher={refresher}
                            />
                            <FreeShippingFeesManagementViewSettingsCategoriesExceptions
                                syncWithDetachedCustomers={syncWithDetachedCustomers}
                                {...customerProps}
                                refresher={refresher}
                            />
                            <FreeShippingFeesManagementViewSettingsPriceLevelsExceptions
                                syncWithDetachedCustomers={syncWithDetachedCustomers}
                                {...customerProps}
                                refresher={refresher}
                            />
                            <FreeShippingFeesManagementViewSettingsCompaniesExceptions
                                syncWithDetachedCustomers={syncWithDetachedCustomers}
                                {...customerProps}
                                refresher={refresher}
                            />
                            <FreeShippingFeesManagementViewSettingsRegionsExceptions
                                syncWithDetachedCustomers={syncWithDetachedCustomers}
                                {...customerProps}
                                refresher={refresher}
                            />
                            {/*<FreeShippingFeesManagementViewSettingsTimeLinesExceptions*/}
                            {/*    syncWithDetachedCustomers={syncWithDetachedCustomers}*/}
                            {/*    {...customerProps}
                            {/*    refresher={refresher}*/}
                            {/*/>*/}
                        </Col>
                    </>
                }
            </div>
        </>
    );
}


export default FreeShippingFeesManagementViewSettings;
